import styled from 'styled-components'
import { theme } from '../../../../../../../style/theme'

export const OrderButtonWrap = styled.div`
	margin-bottom: 1.25em;

	@media screen and (max-width: ${theme.point720}) {
		margin-bottom: 0;
	}
`
OrderButtonWrap.displayName = 'OrderButtonWrap'